import styled from '@emotion/styled'
import { isMobile } from '@const/device'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding: 20px;
  box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;

  ${() =>
    isMobile
      ? ''
      : `
    /* fixed, а не absolute: плашку рисует контейнер страницы с overflow: hidden,
       высота которого зависит от контента. На коротких страницах (например,
       пустое "Мое обучение") он был ниже плашки и срезал её низ вместе с
       последним уведомлением и кнопкой "Показать ещё". Fixed выводит плашку
       из-под этой обрезки. Точные top/right/max-height проставляет List по
       положению колокольчика, здесь только значения до первого замера. */
    position: fixed;
    z-index: 150;
    right: 30px;
    top: 60px;
    max-height: calc(100vh - 72px);
  `}
`
